import { render, staticRenderFns } from "./Bloco4Boletins.vue?vue&type=template&id=467a729b&"
import script from "./Bloco4Boletins.vue?vue&type=script&lang=js&"
export * from "./Bloco4Boletins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports